import { Box, Col, FormGroup, RadioButton, RadioGroup, Row, TextInput } from '@ksyos/design-system';
import type { ITfoDiagnosticReportCustomControlData } from '@common/validation/customControls/ophthalmology';
import { parseBooleanLike } from '@common/utils/booleanLikeUtils';
import { getSelectedLanguage } from '@frontend/translate';
import { useFormContext } from '@frontend/utils/hooks/useFormContext';

export function AndereBevindingenFields() {
    const form = useFormContext<ITfoDiagnosticReportCustomControlData>();
    const translate = getSelectedLanguage();

    return (
        <FormGroup
            hasErrors={
                form.errors.has('andere_bevindingen_od') ||
                form.errors.has('andere_bevindingen_os') ||
                form.errors.has('andere_bevindingen_od_text') ||
                form.errors.has('andere_bevindingen_os_text')
            }
            label="Andere bevindingen"
            layout="horizontal"
        >
            <Row columnGap={2}>
                <Col span={[6, 6]}>
                    <RadioGroup
                        error={form.errors.getMessage('andere_bevindingen_od')}
                        layout="row"
                        name="andere_bevindingen_od"
                        onChange={(value) => {
                            const parsedValue = parseBooleanLike(value.target.value);

                            if (!parsedValue) {
                                form.handleChange([
                                    {
                                        name: 'andere_bevindingen_od',
                                        value: parsedValue,
                                    },
                                    {
                                        name: 'andere_bevindingen_od_text',
                                        value: null,
                                    },
                                ]);
                            } else {
                                form.handleChange({ name: 'andere_bevindingen_od', value: parsedValue });
                            }
                        }}
                        value={form.values.andere_bevindingen_od?.toString() ?? ''}
                    >
                        <RadioButton
                            label={translate.common.yes}
                            value="true"
                        />
                        <RadioButton
                            label={translate.common.no}
                            value="false"
                        />
                    </RadioGroup>
                    {form.values.andere_bevindingen_od && (
                        <>
                            <Box
                                marginTop={1}
                                maxWidth="max-content"
                            >
                                <TextInput
                                    disabled={!form.values.andere_bevindingen_od}
                                    error={form.errors.getMessage('andere_bevindingen_od_text')}
                                    name="andere_bevindingen_od_text"
                                    onChange={(value) =>
                                        form.handleChange({
                                            name: 'andere_bevindingen_od_text',
                                            value: value.target.value,
                                        })
                                    }
                                    placeholder="Beschrijf bevindingen..."
                                    value={form.values.andere_bevindingen_od_text ?? ''}
                                    variant="outline"
                                />
                            </Box>
                            {!form.values.andere_bevindingen_os && <Box></Box>}
                        </>
                    )}
                </Col>
                <Col>
                    <RadioGroup
                        error={form.errors.getMessage('andere_bevindingen_os')}
                        layout="row"
                        name="andere_bevindingen_os"
                        onChange={(value) => {
                            const parsedValue = parseBooleanLike(value.target.value);

                            if (!parsedValue) {
                                form.handleChange([
                                    { name: 'andere_bevindingen_os', value: parsedValue },
                                    { name: 'andere_bevindingen_os_text', value: null },
                                ]);
                            } else {
                                form.handleChange({
                                    name: 'andere_bevindingen_os',
                                    value: parsedValue,
                                });
                            }
                        }}
                        value={form.values.andere_bevindingen_os?.toString() ?? ''}
                    >
                        <RadioButton
                            label={translate.common.yes}
                            value="true"
                        />
                        <RadioButton
                            label={translate.common.no}
                            value="false"
                        />
                    </RadioGroup>
                    {form.values.andere_bevindingen_os && (
                        <>
                            {!form.values.andere_bevindingen_od && <Box></Box>}
                            <Box marginTop={1}>
                                <TextInput
                                    disabled={!form.values.andere_bevindingen_os}
                                    error={form.errors.getMessage('andere_bevindingen_os_text')}
                                    key="andere_bevindingen_os_text"
                                    onChange={(value) =>
                                        form.handleChange({
                                            name: 'andere_bevindingen_os_text',
                                            value: value.target.value,
                                        })
                                    }
                                    placeholder="Beschrijf bevindingen..."
                                    value={form.values.andere_bevindingen_os_text ?? ''}
                                    variant="outline"
                                />
                            </Box>
                        </>
                    )}
                </Col>
            </Row>
        </FormGroup>
    );
}
